import { createBrowserRouter } from 'react-router';
import { publicRoutes } from './public.routes';
import { privateRoutes } from './private.routes';

{
	/* @Adem, future values are used to resolve console warnings */
}
const options = {
	basename: '/',
	future: {
		v7_fetcherPersist: true,
		v7_normalizeFormMethod: true,
		v7_partialHydration: true,
		v7_relativeSplatPath: true,
		v7_skipActionErrorRevalidation: true
	}
};

const routes = [...privateRoutes, ...publicRoutes];

export const router = createBrowserRouter(routes, options);
